/**
 * Time：2020-09-15
 * Author：vvyng@qq.com
 */

//获取时间
export function timeFn (type, obj) {
	function p (s) {
		return s < 10 ? '0' + s : s;
	}
	var myDate = obj ? obj : new Date();
	var year = myDate.getFullYear();
	var month = myDate.getMonth() + 1;
	var date = myDate.getDate();
	var h = myDate.getHours();
	var m = myDate.getMinutes();
	var s = myDate.getSeconds();
	var now = '';
	if (type == 'yyyy-MM-dd HH:mm:ss') {
		now = year + '-' + p(month) + "-" + p(date) + " " + p(h) + ':' + p(m) + ":" + p(s);
	} else if (type == 'yyyy-MM-dd HH:mm') {
		now = year + '-' + p(month) + "-" + p(date) + " " + p(h) + ':' + p(m);
	} else if (type == 'yyyy-MM-dd') {
		now = year + '-' + p(month) + "-" + p(date);
	} else if (type == 'MM-dd') {
		now = p(month) + "-" + p(date);
	} else if (type == 'HH:mm:ss') {
		now = p(h) + ':' + p(m) + ":" + p(s);
	} else if (type == 'HH:mm') {
		now = p(h) + ':' + p(m);
	} else {
		now = year + '年' + p(month) + "月" + p(date) + "日" + p(h) + '时' + p(m) + "分" + p(s) + '秒';
	}
	return now;
}

/* 接口链接 */
export function interfaceFn (urlType) {
  var interfaceUrl = '';
	// interfaceUrl = 'http://www.ypos.vip';
  if(urlType == 1){
    interfaceUrl = 'http://www.ypos.vip';
  }
	return interfaceUrl;
}

//苹果手机
function isApplePhone() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /iPhone|iPod/i.test(userAgent) && !window.MSStream;
}

// 判断是否在时间段内
export function isDuringDateFun (beginDateStr, endDateStr) {
  var nowDate = new Date();
  let timestamp = nowDate.getTime();
  // const timestamp = Date.parse(new Date());//当前时间的时间戳
  let begin = Number(beginDateStr.replaceAll(":", ''));
  let end = Number(endDateStr.replaceAll(":", ''));
  beginDateStr = getToDay() + ' ' + beginDateStr;
  if (end < begin) {//跨天的情况
    endDateStr = getToDay('isTranssky') + ' ' + endDateStr;
  } else {
    endDateStr = getToDay() + ' ' + endDateStr;
  }
  if(isApplePhone()){
    beginDateStr = new Date(beginDateStr.replace(/ /g, 'T')).getTime();
    endDateStr = new Date(endDateStr.replace(/ /g, 'T')).getTime();
  }else{
    beginDateStr = new Date(beginDateStr).getTime();
    endDateStr = new Date(endDateStr).getTime();
  }
  return timestamp >= beginDateStr && timestamp <= endDateStr;
}
function getToDay (isTranssky) {
  let currentDate = new Date();
  let year = currentDate.getFullYear();
  let month = currentDate.getMonth() + 1;
  let day = '';
  if (isTranssky) {
    day = currentDate.getDate() + 1;
  } else {
    day = currentDate.getDate();
  }
  return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
}



// WEBPACK FOOTER //
// ./src/assets/util.js